import {
    REPORT_GET_MULTIPLE,
    REPORT_GET_ONE,
    REPORT_REGISTER_SUCCESS,
    REPORT_REGISTER_FAIL,
    REPORT_LOADING,
    REPORT_LOADING_ERROR,
    REPORT_ACTIVATE_FAIL,
    REPORT_ACTIVATE_SUCCESS,
    REPORT_UPDATE_SUCCESS,
    REPORT_UPDATE_FAIL,
    REPORT_DELETE_SUCCESS,
    REPORT_DELETE_FAIL,
    REPORT_EDIT
} from "./../types/report";

let reportStore = []//JSON.parse(localStorage.getItem('report'))
let schoolStore = JSON.parse(localStorage.getItem('schools'))
let sessionStore = JSON.parse(localStorage.getItem('sessions'))
let termStore = JSON.parse(localStorage.getItem('terms'))
let claszStore = JSON.parse(localStorage.getItem('claszs'))

const initialState = {
    isLoading: false,
    reports: reportStore ? reportStore : {},
    report:{},
    schools: schoolStore ? schoolStore : {},
    sessions: sessionStore ? sessionStore : {},
    terms: termStore ? termStore : {},
    claszs: claszStore ? claszStore : {},
    msg: null,
    isEdit:-1,
    ref:null,
}

const changeState = (aluu, actid) =>
{
    let newReport = [...aluu];
    newReport.forEach(alu => {
        if(alu.id == actid.id){
            alu.is_active = actid.is_active
        }
    });
    return newReport;
}
const func =  function(state = initialState, action){
    switch (action.type) {
        case REPORT_EDIT:
            return {
                ...state,
                isEdit : action.payload
        };
        case REPORT_LOADING:
            return {
                ...state,
                isLoading : true
            };
        case REPORT_GET_MULTIPLE:
            let sc = action.payload[0] || {}
            let se = action.payload[1] || {}
            let te = action.payload[2] || {}
            let cl = action.payload[3] || {}
            let re = action.payload[4] || {}
            localStorage.setItem('schools', JSON.stringify(sc));
            localStorage.setItem('sessions', JSON.stringify(se));
            localStorage.setItem('terms', JSON.stringify(te));
            localStorage.setItem('claszs', JSON.stringify(cl));
            localStorage.setItem('report', JSON.stringify(re));
            return {
                ...state,
                schools : sc,
                sessions : se,
                terms : te,
                claszs : cl,
                reports : re,
                isLoading : false
            };
        case REPORT_GET_ONE:
            let all = [...state.reports];
            let ses = all.filter(row=>row.id == action.payload)[0];
            return {
                ...state,
                report : ses,
                MSG:"DONE!!!"
            };
        case REPORT_REGISTER_SUCCESS:
            localStorage.setItem('report', JSON.stringify([...state.reports, action.payload]));
            return {
                ...state,
                reports: [...state.reports, action.payload],
                msg:action.msg
            }; 
        case REPORT_ACTIVATE_SUCCESS:
            let ac = changeState(state.reports, action.payload);
            localStorage.setItem('report', JSON.stringify(ac));
            return{
                ...state,
                msg:'DONE!!!',
                reports: ac
            }
        case REPORT_DELETE_SUCCESS:
            let rem = state.reports.filter(cat => cat.id != action.payload);
            localStorage.setItem('report', JSON.stringify(rem));
            return{
                ...state,
                msg:'DONE!!!',
                reports: rem
            }
        case REPORT_UPDATE_SUCCESS:
            const findInd = state.reports.findIndex(cat => cat.id == action.payload.id);
            let newState = [...state.reports];
            newState[findInd] = action.payload;
            localStorage.setItem('report', JSON.stringify(newState));
            return {
                ...state,
                ...action.payload,
                reports : newState,
                report:action.payload
            }; 
        case REPORT_LOADING_ERROR:
        case REPORT_ACTIVATE_FAIL:
        case REPORT_REGISTER_FAIL:
        case REPORT_DELETE_FAIL:
        case REPORT_UPDATE_FAIL:
            localStorage.removeItem('schools');
            localStorage.removeItem('sessions');
            localStorage.removeItem('terms');
            localStorage.removeItem('claszs');
            localStorage.removeItem('report');
            return {
                ...state,
                isLoading: false,
                reports:{},
                sessions:{},
                schools:{},
                terms:{},
                claszs:{},
                msg: action.msg
            };
        default:
            return state;
    }

}
export default func